import Box from '@mui/material/Box';
import MuiDrawer, { drawerClasses, DrawerProps } from '@mui/material/Drawer';
import { SxProps, Theme } from '@mui/material/styles';

// The paper itself must end above the Ask Tread dock: shortening only a child is undone by the
// paper's column flex layout, which stretches that child back to full height. Set through the
// root sx so callers' PaperProps/slotProps and paper sx rules still apply.
const reserveDockSpaceSx: SxProps<Theme> = {
  [`& .${drawerClasses.paper}`]: {
    height: 'calc(100dvh - var(--tread-agent-dock-height, 0px))',
  },
};

export function Drawer({
  anchor = 'right',
  children,
  onClose,
  open,
  sx,
  ...rest
}: DrawerProps) {
  return (
    <MuiDrawer
      anchor={anchor}
      open={open}
      onClose={onClose}
      sx={[reserveDockSpaceSx, ...(Array.isArray(sx) ? sx : [sx])]}
      {...rest}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        {children}
      </Box>
    </MuiDrawer>
  );
}
